(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.managersettings', indexController);    

    indexController.$inject = ["modules.goals.service", "base.service", "$mdToast", "$rootScope", "$mdDialog"];    

    function indexController(engagementGoalsService, baseService, $mdToast, $rootScope, $mdDialog) {
        var vm = this;    

        vm.ReportPeriodTypes = [
            {
                Name: 'Vecka',
                Id: 1
            },
            {
                Name: 'Månad',
                Id: 2
            }
        ];

        vm.DatePickerSettings = {
            min: BizPartCoreHelpers.getDateNow().startOf('year')
        };

        vm.DayList = [];

        vm.Init = Init;   
        vm.GetMeetingInfo = GetMeetingInfo;
        vm.SavePeriodMode = SavePeriodMode;
        vm.SaveMeetingInfo = SaveMeetingInfo;
        vm.GetMeetings = GetMeetings;
        vm.SaveMeeting = SaveMeeting;
        vm.DeleteMeeting = DeleteMeeting;
        vm.MeetingHasPassed = MeetingHasPassed;

        function SavePeriodMode() {
            engagementGoalsService.SetPeriodMode(vm.PeriodMode, vm.SelectedUnit.Id).then(SetPeriodModeCallback);

            function SetPeriodModeCallback(response) {
                vm.OriginalPeriodMode = vm.PeriodMode;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Period ändrad')
                        .position('bottom right')
                );
            }
        }

        function SaveMeetingInfo() {

            engagementGoalsService.SetMeetingInfo(vm.MeetingInfo.PeriodType, vm.MeetingInfo.MeetingDay, vm.SelectedUnit.Id).then(SetMeetingInfoCallback);

            function SetMeetingInfoCallback(response) {
                vm.OriginalMeetingInfo = angular.copy(vm.MeetingInfo);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Rapportinställningar ändrad')
                        .position('bottom right')
                );
            }
        }

        function SaveMeeting() {
            
            engagementGoalsService.CreateUpdateMeeting({
                Date: vm.AddMeetingDate,
                UnitId: vm.SelectedUnit.Id
            }).then(CreateUpdateMeetingCallback);

            function CreateUpdateMeetingCallback(response) {
                var meeting = BizPartCoreHelpers.getResponseValue(response);
                vm.MeetingList.push(meeting);

                vm.ShowNewMeeting = false;
                vm.AddMeetingDate = undefined;
            }
        }

        function GetMeetingInfo() {
            engagementGoalsService.GetMeetingInfo().then(GetMeetingInfoCallback);

            function GetMeetingInfoCallback(response) {
                vm.MeetingInfo = BizPartCoreHelpers.getResponseValue(response);
                vm.OriginalMeetingInfo = angular.copy(vm.MeetingInfo);
            }
        }

        function GetMeetings() {
            engagementGoalsService.GetMeetings(vm.SelectedUnit.Id).then(GetMeetingsCallback);

            function GetMeetingsCallback(response) {
                vm.MeetingList = BizPartCoreHelpers.getResponseValue(response);
            }
        }

        function DeleteMeeting(meeting) {            
            
            var confirm = $mdDialog.confirm()
                .title('Radera')
                .textContent('Är du säker på att du vill radera detta "mötet"?')
                .ok('Ja')
                .cancel('Avbryt');

            $mdDialog.show(confirm).then(function () {
                engagementGoalsService.DeleteMeeting(meeting.Id).then(DeleteMeetingCallback);
            }, function () {

            });
            
            
            function DeleteMeetingCallback(response) {
                var index = vm.MeetingList.indexOf(meeting);
                vm.MeetingList.splice(index, 1);
            }
        }

        function MeetingHasPassed(meeting) {            
            return BizPartCoreHelpers.getDateNow().startOf('day') > moment(meeting.Date).startOf('day');            
        }

        function Init() {            
            vm.User = $rootScope.LoggedInUser;
            if (vm.User.Units.length > 0) {
                vm.SelectedUnit = vm.User.Units[0];
            }

            for (var i = 1; i < 8; i++) {
                vm.DayList.push({
                    Name: moment.weekdays(i),
                    Id: i
                });
            }

            vm.GetMeetingInfo();
            vm.PeriodModeList = engagementGoalsService.GetPeriodModes();
            vm.PeriodMode = vm.OriginalPeriodMode = baseService.GetFrontEndModuleSettingValue('Goals', 'PeriodMode');
            vm.GetMeetings();            
        }

        $rootScope.Initialized.then(vm.Init);
    }
    
})(window.angular);
